import { createSlice } from '@reduxjs/toolkit';
import { Country } from 'App/i18n/enums';
import { IStoreInfo } from './types';

const setStoreInfo = (state: IStoreInfo, action: any) =>
  (state = action.payload);

const storeInfoInitialState: IStoreInfo = {
  id: '1',
  name: '1',
  url: '1',
  country: 'AR',
  language: 'es',
  currency: 'ARS',
  flags: [],
  kycFlags: [],
  owner: {
    name: '1',
    email: '1',
    document: '1',
    country: Country.ARGENTINA,
  },
};

const storeInfoSlice = createSlice({
  name: 'storeInfo',
  initialState: storeInfoInitialState,
  reducers: {
    setStoreInfoAction: setStoreInfo,
    setKycFlagsAction: (state, action) => {
      state.kycFlags = action.payload;
    },
  },
});

export const { setStoreInfoAction, setKycFlagsAction } = storeInfoSlice.actions;

export default storeInfoSlice.reducer;
